import { createContext, useContext } from 'react';
var NavBarContext =
/*#__PURE__*/
createContext({
  closePanel: function closePanel() {
    return void 0;
  }
});

var useNavBarContext = function useNavBarContext() {
  return useContext(NavBarContext);
};

export { NavBarContext, useNavBarContext };